import {Component, input, output, inject} from '@angular/core';
import {BankingSettings} from '../../../classes/models/store/BankingSettings';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BankingSettingsFormComponent} from './banking-settings-form/banking-settings-form.component';
import {DataService} from '../../../services/store/data.service';
import {TableHeader} from '../../../shared/classes/TableHeader';
import {BankingSettingsDeleteComponent} from './banking-settings-delete/banking-settings-delete.component';
import {SHARED_IMPORTS} from "../../../shared/standalone-imports";

/**
 * This component handles displaying and editing banking requirements.
 */
@Component({
  selector: 'app-banking-settings',
  templateUrl: './banking-settings.component.html',
  styleUrls: ['./banking-settings.component.less'],
  imports: [SHARED_IMPORTS]
})
export class BankingSettingsComponent {
  private modalService = inject(NgbModal);
  dataService = inject(DataService);

  /** An identifier of a store. */
  readonly storeId = input<string>(undefined);
  /** A list of banking requirements to be displayed. */
  readonly bankingSettings = input<BankingSettings[]>([]);
  /** An event to refresh store page data. */
  readonly getStoreDetailsEvent = output();

  /** Headers of a banking requirements table. */
  headers: TableHeader[] = [
    new TableHeader('Banking days', 'days', false),
    new TableHeader('Start date', 'startDate', false),
    new TableHeader('', '', false)
  ];

  /**
   * Checks if data is allowed to edit at the given date.
   * @param date the date on which data might be edited.
   */
  canEditAtDate(date: string): boolean {
    return this.dataService.canEditAtDate(date);
  }

  /**
   * Opens a modal window to create new banking settings.
   */
  openCreate(): void {
    const modalRef = BankingSettingsFormComponent.open(this.modalService, {
      storeId: this.storeId(),
      previousBankingSettings: undefined,
      weekExists: false
    });
    modalRef.result.then(() => {
      this.getStoreDetailsEvent.emit();
    });
  }

  /**
   * Opens a modal window to update banking settings.
   */
  openUpdate(bankingSettings: BankingSettings): void {
    const modalRef = BankingSettingsFormComponent.open(this.modalService, {
      storeId: this.storeId(),
      previousBankingSettings: bankingSettings,
      weekExists: true
    });
    modalRef.result.then(() => {
      this.getStoreDetailsEvent.emit();
    });
  }

  /**
   * Opens a modal window to delete an existing banking settings.
   * @param date the date, from which banking settings should be deleted.
   */
  openDelete(date: string): void {
    const modalRef = BankingSettingsDeleteComponent.open(this.modalService, {
      storeId: this.storeId(),
      date: date
    });
    modalRef.result.then(() => {
      this.getStoreDetailsEvent.emit();
    });
  }
}